import React, { useEffect, useState } from 'react';
import { SelectArrayInputProps } from 'react-admin';

import { SelectArrayInput } from '@components';
import { stateHttp } from '@network/state-http';

interface Props extends SelectArrayInputProps {
  nameOnly?: boolean;
}

export const CreditStatesFilter = (props: Props) => {
  const [options, setOptions] = useState<{id: number | string; name: string}[]>([]);

  useEffect(() => {
    (async () => {
      const states = await stateHttp.getAll();
      setOptions(states.map(state => ({
        id: props.nameOnly ? state.name : state.id,
        name: state.name,
      })));
    })();
  }, []);

  return (
    <SelectArrayInput
      {...props}
      choices={options}
      className="MS-field"
      style={{ width: 280 }}
      alwaysOn
    />
  );
};
